module.exports = __webpack_public_path__ + "img/primary-folder.9a4a5635.svg";